import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Reveal, GoldButton } from "@/components/bits/Reveal";
import { IMAGES, INDUSTRIES } from "@/data/content";
import { useSEO } from "@/lib/seo";

export default function Industries() {
  useSEO(
    "Industries We Serve | Automotive, Electronics, Defence & Solar — Maqline Solutions Pvt Ltd",
    "Maqline Solutions Pvt Ltd provides industrial manpower and recruitment for automotive, manufacturing, engineering, electronics, defence manufacturing, precision components and solar sectors."
  );

  return (
    <main data-testid="industries-page">
      <PageHero
        overline="Industries"
        titleLines={["Nine sectors.", "One standard of workforce."]}
        description="Each industry has its own workforce reality — trades, shifts, disciplines. Here is exactly how Maqline supports each one."
        image={IMAGES.solar}
      />

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="space-y-6">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.num} delay={0.05}>
                <div
                  data-testid={`industry-detail-${ind.num}`}
                  className="group grid grid-cols-1 lg:grid-cols-12 gap-8 border border-ink/10 hover:border-gold/50 rounded-sm p-7 sm:p-10 transition-all duration-500 hover:shadow-[0_18px_44px_rgba(6,27,58,0.08)]"
                >
                  <div className="lg:col-span-4 flex gap-6">
                    <span className="font-mono text-4xl text-gold/40 group-hover:text-gold font-bold transition-colors duration-300">{ind.num}</span>
                    <div>
                      <h2 className="font-display text-2xl sm:text-3xl text-ink tracking-tight">{ind.name}</h2>
                      <p className="text-sm text-muted mt-3 leading-relaxed">{ind.workforce}</p>
                    </div>
                  </div>
                  <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
                    <div>
                      <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-gold mb-2">Candidate Categories</p>
                      <p className="text-sm text-ink/75 leading-relaxed">{ind.candidates}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-gold mb-2">Potential Roles</p>
                      <p className="text-sm text-ink/75 leading-relaxed">{ind.roles}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-gold mb-2">How Maqline Supports</p>
                      <p className="text-sm text-ink/75 leading-relaxed">{ind.support}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-16 bg-darknavy noise-bg rounded-sm p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
              <div>
                <h3 className="font-display text-2xl sm:text-3xl text-white">Need workforce in any of these sectors?</h3>
                <p className="text-white/55 text-sm mt-2">Share your requirement and we'll structure sourcing around your industry.</p>
              </div>
              <Link to="/businesses#request" data-testid="industries-cta"><GoldButton>Request Manpower <ArrowRight size={15} /></GoldButton></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
